// AuthContext.js

import React, { createContext, useContext, useEffect, useState } from "react";
import {
  clearAllLogoutFlags,
  clearIntentionalLogout,
  markIntentionalLogout,
} from "./utils/logoutManager";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessToken") || null
  );

  useEffect(() => {
    if (accessToken) {
      setIsAuthenticated(true);
    }
  }, [accessToken]);

  const login = (token) => {
    localStorage.setItem("accessToken", token);
    setAccessToken(token);
    setIsAuthenticated(true);
    // Limpiar las banderas de alerta
    localStorage.removeItem("sessionExpiredAlertShown");
    localStorage.removeItem("intentionalLogout");
  };

  const logout = () => {
    // console.log("🔄 Iniciando proceso de logout...");

    // Marcar que el logout es intencional para evitar alertas
    markIntentionalLogout();
    // console.log("✅ Logout marcado como intencional");

    // Limpiar todas las banderas y tokens
    localStorage.removeItem("accessToken");
    localStorage.removeItem("token");
    localStorage.removeItem("sessionExpiredAlertShown");
    // console.log("✅ Tokens y banderas limpiados del localStorage");

    // Limpiar el estado de la aplicación
    setAccessToken(null);
    setIsAuthenticated(false);
    // console.log("✅ Estado de la aplicación limpiado");

    // Limpiar la bandera de logout intencional después de 3 segundos
    // para evitar que persista en futuras sesiones
    setTimeout(() => {
      clearIntentionalLogout();
      // console.log("⏰ Bandera de logout intencional limpiada automáticamente");
    }, 3000);

    // console.log("🎯 Logout completado exitosamente");
  };

  // Función para limpiar todas las banderas de alerta
  const clearAllFlags = () => {
    clearAllLogoutFlags();
  };

  // Función para forzar logout sin alertas (emergencia)
  const forceLogout = () => {
    // console.log("🚨 Forzando logout de emergencia...");

    // Marcar logout intencional inmediatamente
    markIntentionalLogout();

    // Limpiar todo inmediatamente
    localStorage.clear();
    setAccessToken(null);
    setIsAuthenticated(false);

    // console.log("🚨 Logout de emergencia completado");
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, login, logout, clearAllFlags, forceLogout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
